import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { ButtonAction, DialogData } from './dialog-data';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { TextService } from '../text.service';
import { ButtonColor } from '../button/button.component';

const defaultDialogConfig: MatDialogConfig<unknown> = {
  maxWidth: 465,
  autoFocus: true,
  hasBackdrop: true,
};

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialog = inject(MatDialog);
  private text = inject(TextService);

  open(component: ComponentType<unknown>, config?: MatDialogConfig<unknown>) {
    const myConfig = config ? { ...defaultDialogConfig, ...config } : defaultDialogConfig;

    this.dialog.closeAll();

    return this.dialog.open(component, myConfig);
  }

  close() {
    this.dialog.closeAll();
  }

  confirm(data: DialogData) {
    return this.open(ConfirmDialogComponent, {
      data,
    });
  }

  info(data: DialogData) {
    return this.open(InfoDialogComponent, {
      data,
    });
  }

  deleteDialog(name: string, secondTitle?: string, text?: string) {
    const dialogData = {
      title: secondTitle ? '' : `${this.text.get('delete')} ${name}`,
      secondTitle: secondTitle,
      text: text ? text : `${this.text.get('delete_dialog_text')} ${name}?`,
      buttons: [
        {
          text: this.text.get('delete'),
          color: 'warning' as ButtonColor,
          action: 'first' as ButtonAction,
        },
      ],
    };
    return this.info(dialogData);
  }
}
